<template>
  <div class="basic_wrap pay-password-page">
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('setpaypwd.modifyPaymentPassword') }}
      </div>
    </div>

    <div class="form-card">
      <div class="write_box">
        <input
          v-model="password"
          :type="passwordInp"
          :placeholder="$t('setpaypwd.loginpassword')"
        >
        <button
          type="button"
          class="eye_bi"
          :class="passwordInp == 'text' ? 'eye' : ''"
          @click="showPwd"
        />
      </div>

      <div class="write_box">
        <div
          class="wordBox"
          @click="showWord(1)"
        >
          <input
            v-model="npassword"
            :type="newpasswordInp"
           
            :placeholder="$t('setpaypwd.newpassword')"
          >
        </div>
        <button
          type="button"
          class="eye_bi"
          :class="newpasswordInp == 'text' ? 'eye' : ''"
          @click="showNewsPwd"
        />
      </div>

      <div class="write_box">
        <div
          class="wordBox"
          @click="showWord(2)"
        >
          <input
            v-model="rpassword"
            :type="newpasswordInp"
           
            :placeholder="$t('setpwd.confirmnewpassword')"
          >
        </div>
        <button
          type="button"
          class="eye_bi"
          :class="newpasswordInp == 'text' ? 'eye' : ''"
          @click="showNewsPwd"
        />
      </div>
    </div>

    <button
      v-if="codeStatus"
      type="button"
      class="basic_btn"
      :class="rpassword != '' && code != '' && npassword != '' ? '' : 'no_touch'"
      @click="dxRevise"
    >
      {{ $t('setpwd.modify') }}
    </button>
    <button
      v-if="!codeStatus"
      type="button"
      class="basic_btn"
      :class="password != '' && rpassword != '' && npassword != '' ? '' : 'no_touch'"
      @click="oldRevise"
    >
      {{ $t('setpwd.modify') }}
    </button>

    <van-popup
      v-model="write_psd"
      closeable
      close-icon="close"
      round
      position="bottom"
      class="pay-popup"
    >
      <div class="psw_box">
        <van-password-input
          :value="psd_val"
          :mask="true"
          :focused="showKeyboard"
          @focus="showKeyboard = true"
        />
        <div class="keybord_box">
          <div class="keybord">
            <button
              v-for="key in keyboardKeys"
              :key="key.key"
              type="button"
              class="key_item"
              :class="key.className"
              @click="handleKeyboardKey(key)"
            >
              <span class="key_inner">
                {{ key.label }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import {
	Popup,
	PasswordInput,
} from "vant";
import Fetch from "../../utils/fetch";

Vue.use(PasswordInput).use(Popup);

export default {
	name: "Setpwd",
	data() {
		return {
			showKeyboard: true,
			choose_tick: false,
			write_psd: false,
			time: 0,
			password: "",
			rpassword: "",
			npassword: "",
			mobile: "",
			ycmobile: "",
			passwordInp: "password",
			newpasswordInp: "password",
			codeStatus: false,
			psd_val: "",
			codeOK: false,
			code: "",
			is_send: false,
			nowInput: 1,
			keyboardKeys: [
				{ key: "1", label: "1", value: 1 },
				{ key: "2", label: "2", value: 2 },
				{ key: "3", label: "3", value: 3 },
				{ key: "4", label: "4", value: 4 },
				{ key: "5", label: "5", value: 5 },
				{ key: "6", label: "6", value: 6 },
				{ key: "7", label: "7", value: 7 },
				{ key: "8", label: "8", value: 8 },
				{ key: "9", label: "9", value: 9 },
				{ key: "blank", label: "", className: "no_bg" },
				{ key: "0", label: "0", value: 0 },
				{ key: "delete", label: "x", action: "delete", className: "no_bg x" },
			],
		};
	},
	created() {
		this.$parent.footer("user", false);
	},
	mounted() {
		Fetch("/user/info").then(r => {
			this.mobile = r.data.mobile;
			this.ycmobile = r.data.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
		});
	},
	methods: {
		showWord(n) {
			this.nowInput = n == 1 ? 1 : 2;
			this.psd_val = "";
			this.write_psd = true;
		},
		handleKeyboardKey(key) {
			if (key.action === "delete") {
				this.onDelete();
				return;
			}
			if (typeof key.value === "number") {
				this.onInput(key.value);
			}
		},
		onInput(key) {
			this.psd_val = (this.psd_val + key).slice(0, 6);
			if (this.psd_val.length == 6) {
				if (this.nowInput == 1) {
					this.npassword = this.psd_val;
				} else {
					this.rpassword = this.psd_val;
				}
				this.write_psd = false;
			}
		},
		onDelete() {
			this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
		},
		cutType(n) {
			this.codeStatus = n == 1;
			this.rpassword = "";
			this.npassword = "";
		},
		timeCall() {
			this.is_send = false;
			this.time = 0;
		},
		sendcode() {
			if (this.is_send) {
				return;
			}

			this.is_send = true;

			Fetch("/index/forgetpwd_email_code", {
				mobile: this.mobile,
			}).then(() => {
				this.time = 120 * 1000;
				this.$toast({
					background: "#07c160",
					message: this.$t("setpwd.sendsuccessfully"),
				});
			}).catch(() => {
				this.is_send = false;
			});
		},
		showPwd() {
			this.passwordInp = this.passwordInp == "password" ? "text" : "password";
		},
		showNewsPwd() {
			this.newpasswordInp = this.newpasswordInp == "password" ? "text" : "password";
		},
		dxRevise() {
			if (!this.npassword) {
				this.$toast(this.$t("setpaypwd.newpasswordcannotbeempty"));
				return false;
			}

			if (this.npassword !== this.rpassword) {
				this.$toast(this.$t("setpaypwd.inconsistent"));
				return false;
			}

			Fetch("/user/resetpaypwd_code", {
				code: this.code,
				npassword: this.npassword,
			}).then(() => {
				this.$toast({
					background: "#07c160",
					message: this.$t("setpwd.modifiedsuccessfully"),
				});

				sessionStorage.setItem("pwd", this.npassword);

				if (this.$route.query.redirect) {
					this.$router.replace(this.$route.query.redirect + "?change");
				} else {
					this.$router.replace("/set");
				}
			});
		},
		oldRevise() {
			if (!this.password) {
				this.$toast(this.$t("setpaypwd.loginpasswordcannotbeempty"));
				return false;
			}

			if (!this.npassword) {
				this.$toast(this.$t("setpaypwd.newpasswordcannotbeempty"));
				return false;
			}

			if (this.npassword !== this.rpassword) {
				this.$toast(this.$t("setpaypwd.inconsistent"));
				return false;
			}
			var reg = new RegExp("^[0-9]*$");
			if (!reg.test(this.npassword)) {
				this.$toast(this.$t("setpaypwd.pureNumber"));
				return false;
			}
			if (!reg.test(this.rpassword)) {
				this.$toast(this.$t("setpaypwd.pureNumber"));
				return false;
			}
			Fetch("/user/resetpaypwd", {
				passwd: this.password,
				npasswd: this.npassword,
			}).then(() => {
				this.$toast({
					background: "#07c160",
					message: this.$t("setpwd.modifiedsuccessfully"),
				});

				this.$router.replace("/set");
			});
		},
	},
};
</script>

<style lang="less" scoped>
.pay-password-page {
	min-height: 100vh;
	background: #fff;
	color: #16223a;
	padding-bottom: 88px;
	box-sizing: border-box;
}

.page-top {
	height: 44px;
	background: #fff;
	color: #16223a;
	border-bottom: 1px solid rgba(240, 242, 245, 1);
	box-sizing: border-box;

	.back_left {
		// filter: invert(1);
		opacity: 0.88;
	}

	.big_tit {
		color: #16223a;
	}
}

.form-card {
	margin: 16px 16px 0;
	padding: 4px 16px 18px;
	border-radius: 14px;
	border: 1px solid rgba(255, 93, 122, 0.16);
	background: #fff;
	box-shadow: 0 12px 22px rgba(22, 34, 58, 0.08);
	box-sizing: border-box;
}

.write_box {
	width: 100%;
	height: 46px;
	margin-top: 14px;
	padding: 0 12px;
	display: flex;
	align-items: center;
	border-radius: 10px;
	border: 1px solid rgba(255, 93, 122, 0.32);
	background: #fff6f8;
	box-sizing: border-box;
}

.wordBox {
	min-width: 0;
	flex: 1;
}

.write_box input,
.wordBox input {
	width: 100%;
	height: 22px;
	border: 0;
	background: transparent;
	color: #16223a;
	font-size: 14px;
	line-height: 22px;
	outline: none;
	-webkit-text-fill-color: #16223a;
}

.write_box input::placeholder,
.wordBox input::placeholder {
	color: #727d91;
	-webkit-text-fill-color: #727d91;
}

.write_box:focus-within {
	border-color: rgba(255, 93, 122, 0.52);
	box-shadow: 0 0 0 3px rgba(255, 93, 122, 0.1);
}

.write_box input:-webkit-autofill,
.write_box input:-webkit-autofill:hover,
.write_box input:-webkit-autofill:focus,
.wordBox input:-webkit-autofill,
.wordBox input:-webkit-autofill:hover,
.wordBox input:-webkit-autofill:focus {
	-webkit-text-fill-color: #16223a;
	box-shadow: 0 0 0 1000px #fff6f8 inset;
	caret-color: #ff5d7a;
}

.eye_bi {
	width: 24px;
	height: 28px;
	flex: 0 0 24px;
	margin-left: 10px;
	border: 0;
	background: url(../images/user/eye2.png) no-repeat center center;
	background-size: 21px auto;
	filter: invert(1);
	opacity: 0.72;
	padding: 0;
}

.eye_bi.eye {
	background-image: url(../images/user/eye1.png);
}

.basic_btn {
	width: calc(100% - 32px);
	height: 46px;
	margin: 24px 16px 0;
	border: 1px solid rgba(255, 93, 122, 0.42);
	border-radius: 10px;
	background: linear-gradient(180deg, #ff7791 0%, #ff5574 100%);
	color: #fff;
	font-size: 14px;
	font-weight: 700;
	line-height: 20px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.basic_btn.no_touch {
	pointer-events: none;
	opacity: 0.46;
}

/deep/ .pay-popup {
	background: #fff;
	color: #16223a;
}

/deep/ .van-popup__close-icon {
	color: #ff5d7a;
}

.psw_box {
	padding-top: 28px;
}

/deep/ .van-password-input {
	margin: 22px 28px 0;
}

/deep/ .van-password-input__security li {
	background: #fff;
	border: 1px solid rgba(255, 93, 122, 0.32);
}

/deep/ .van-password-input__security i {
	background: #ff5d7a;
}

.keybord_box {
	margin-top: 28px;
	padding: 18px 12px 24px;
	background: #fff6f8;
}

.keybord {
	width: 100%;
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	gap: 8px;
}

.key_item {
	height: 44px;
	border: 1px solid rgba(255, 93, 122, 0.24);
	border-radius: 8px;
	background: #fff;
	color: #16223a;
	font-size: 18px;
	font-weight: 700;
}

.key_item.no_bg {
	border-color: transparent;
	background: transparent;
}

.key_item.x {
	color: #6d7688;
}

.key_inner {
	display: inline-block;
	line-height: 44px;
}

@media screen and (max-width: 374px) {
	.form-card {
		margin-right: 12px;
		margin-left: 12px;
		padding-right: 14px;
		padding-left: 14px;
	}

	.basic_btn {
		width: calc(100% - 24px);
		margin-right: 12px;
		margin-left: 12px;
	}
}

.pay-password-page {
	min-height: 100vh;
	padding-bottom: calc(84px + env(safe-area-inset-bottom));
	background: #201c1d;
	color: #f4ece7;
}

.page-top {
	background: #201c1d;
	color: #f3c99e;
	border-bottom-color: #302723;
}

.page-top .back_left {
	opacity: 1;
	filter: brightness(0) saturate(100%) invert(86%) sepia(18%) saturate(702%) hue-rotate(333deg) brightness(99%) contrast(92%);
}

.page-top .big_tit {
	color: #f3c99e;
}

.form-card {
	margin: 14px 10px 0;
	padding: 4px 14px 16px;
	border: 1px solid #75654f;
	border-radius: 9px;
	background: linear-gradient(110deg, #232323, #303030);
	box-shadow: 0 10px 24px rgba(0, 0, 0, .2);
}

.write_box {
	height: 48px;
	margin-top: 12px;
	border-color: #75654f;
	border-radius: 7px;
	background: #282524;
}

.write_box input,
.wordBox input {
	color: #f4ece7;
	-webkit-text-fill-color: #f4ece7;
}

.write_box input::placeholder,
.wordBox input::placeholder {
	color: #a99584;
	-webkit-text-fill-color: #a99584;
}

.write_box:focus-within {
	border-color: #f3c99e;
	box-shadow: 0 0 0 3px rgba(243, 201, 158, .12);
}

.write_box input:-webkit-autofill,
.write_box input:-webkit-autofill:hover,
.write_box input:-webkit-autofill:focus,
.wordBox input:-webkit-autofill,
.wordBox input:-webkit-autofill:hover,
.wordBox input:-webkit-autofill:focus {
	-webkit-text-fill-color: #f4ece7;
	box-shadow: 0 0 0 1000px #282524 inset;
	caret-color: #f3c99e;
}

.eye_bi {
	filter: brightness(0) saturate(100%) invert(86%) sepia(18%) saturate(702%) hue-rotate(333deg) brightness(99%) contrast(92%);
	opacity: .84;
}

.basic_btn {
	width: calc(100% - 20px);
	height: 44px;
	margin: 18px 10px 0;
	border: 0;
	border-radius: 7px;
	background: linear-gradient(120deg, #f5cfa8, #dbab73) !important;
	color: #5a4839 !important;
	box-shadow: 0 6px 14px rgba(0, 0, 0, .22);
}

/deep/ .pay-popup {
	background: #282524;
	color: #f4ece7;
}

/deep/ .van-popup__close-icon {
	color: #f3c99e;
}

/deep/ .van-password-input__security li {
	border-color: #75654f;
	background: #201c1d;
}

/deep/ .van-password-input__security i {
	background: #f3c99e;
}

.keybord_box {
	background: #201c1d;
}

.key_item {
	border-color: #75654f;
	background: #302c29;
	color: #f4ece7;
}

.key_item.x {
	color: #b28d6c;
}

@media screen and (max-width: 374px) {
	.form-card {
		margin-right: 8px;
		margin-left: 8px;
	}

	.basic_btn {
		width: calc(100% - 16px);
		margin-right: 8px;
		margin-left: 8px;
	}
}
</style>
